import { Button, Form, Input, Select } from "antd";
import { useDiscount } from "./DiscountStore";

export default function Add() {
    // `code`, `type`, `amount`, `limittime`, `created_at`
    let {addDiscount} = useDiscount()
    return (
        <Form
            onFinish={addDiscount}
            layout="vertical"
        >
            <Form.Item
                name="code"
                label="Kodi"
                rules={[{ required: true }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name="type"
                label="Turi"
                rules={[{ required: true }]}
            >
                <Select
                    options={[
                        { value: 'fixed', label: 'Summa' },
                        { value: 'percent', label: 'Foiz' },
                    ]}
                />
            </Form.Item>
            <Form.Item
                name="amount"
                label="Miqdor"
                rules={[{ required: true }]}
            >
                <Input type="number" />
            </Form.Item>
            <Form.Item
                name="limittime"
                label="Muddati"
                rules={[{ required: true }]}
            >
                <Input type="date" />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">Qo'shish</Button>
            </Form.Item>
        </Form>
    )
}